import classNames from 'classnames';
import React from 'react';
import LazyLoad from 'react-lazyload';

import { getLink } from '../urls';

import Image from './image';
import Link from './link';

const RelatedReadingTile = (props) => {
  const { reading, tall, noLabel } = props;

  const tileImageClasses = classNames({
    'magazine-teaser__image-wrapper': true,
    'magazine-teaser__image-wrapper--tall': tall,
  });

  return (
    <div className="related-reading-tile magazine-teaser-list__item">
      <article className="magazine-teaser">
        <LazyLoad height={200} offset={400}>
          <Link link={getLink(reading)} className="magazine-teaser__link">
            <div className={tileImageClasses}>
              {reading.main_image && (
                <div className="magazine-teaser__image">
                  <Image image={reading.main_image} alt={reading.main_image.title} />
                </div>
              )}
            </div>
            <div className="magazine-teaser__text">
              {!noLabel && reading.post_category ? (
                <span className="magazine-teaser__category">{reading.post_category}</span>
              ) : (
                <span className="magazine-teaser__category">{reading.title}</span>
              )}

              {reading.title && reading.post_category ? (
                <span className="magazine-teaser__title" itemProp="name">
                  {reading.title}
                </span>
              ) : (
                <p className="magazine-teaser__title" itemProp="description">
                  {reading.subtitle}
                </p>
              )}
            </div>
          </Link>
        </LazyLoad>
      </article>
    </div>
  );
};

export default RelatedReadingTile;
